import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CycleTimeComponent } from '../cycle-time/cycle-time.component';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-cycle-time-cell',
    imports: [CycleTimeComponent],
    templateUrl: './cycle-time-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CycleTimeCellComponent implements ICellRendererAngularComp {
  public text = '';
  public autoIncrease = true;
  public classes = '';

  public agInit(params: ICellRendererParams): void {
    this.text = params.valueFormatted ?? params.value ?? '';
    this.autoIncrease = params.context?.autoIncrease || false;
  }

  public refresh(params: ICellRendererParams): boolean {
    this.text = params.valueFormatted ?? params.value ?? '';
    this.autoIncrease = params.context?.autoIncrease || false;
    return true;
  }
}
